import { render } from "./Molde-Fechado.vue?vue&type=template&id=13857005&scoped=true"
import script from "./Molde-Fechado.vue?vue&type=script&lang=js"
export * from "./Molde-Fechado.vue?vue&type=script&lang=js"

import "./Molde-Fechado.vue?vue&type=style&index=0&id=13857005&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13857005"]])

export default __exports__